export default __webpack_public_path__ + "static/fast-cc63e1ebfe15c93a41ed25cf7f8dd995.png";